import { InputValidated, Row, RowSize, Tooltip } from "@/components";
import styles from "./styles.scss";
import { NumberConfiguraions } from "@/pages/requests/components/visit-details-form/config";
import {
  VisitDetailsField,
  VisitDetailsFieldLabel,
} from "@/pages/requests/components/visit-details-form/types";
import { removeLeadingZero } from "@/utils";
import { selectRequestFormStore, useBoundStore } from "@/services";
import { NumbersWOPProps } from "./types";
import { useFormContext } from "react-hook-form";
import { InfoCircled } from "@/assets/icons";
import clsx from "clsx";

export const NumbersWOP = ({
  onNumbersChange,
  hasPersonnels,
}: NumbersWOPProps) => {
  const { requestFormData } = useBoundStore(selectRequestFormStore);

  const {
    formState: { errors },
  } = useFormContext();

  return (
    <Row size={RowSize.Small} className={styles.inputsGroup}>
      {NumberConfiguraions.map((field, index) => {
        const isNumberOfPersonnelField =
          field === VisitDetailsField.NumberOfPersonnel;

        const tooltipTitle =
          isNumberOfPersonnelField && hasPersonnels
            ? "The number will be auto calculated from Persons List"
            : "";

        return (
          <Tooltip key={index} title={tooltipTitle}>
            <div className={styles.inputItem} key={index}>
              <InputValidated
                label={
                  <div className={styles.inputLabelContainer}>
                    {
                      VisitDetailsFieldLabel[
                        field as keyof typeof VisitDetailsFieldLabel
                      ]
                    }
                    <InfoCircled
                      className={clsx(
                        styles.infoCircleIcon,
                        !tooltipTitle && styles.hidden,
                      )}
                    />
                  </div>
                }
                type="number"
                value={removeLeadingZero(
                  `${requestFormData?.[field as keyof typeof requestFormData]}`,
                )}
                onChange={e => onNumbersChange(e.target.value, field)}
                min="0"
                placeholder="0"
                disabled={isNumberOfPersonnelField}
                errorMessage={(errors?.[field]?.message as string) || undefined}
              />
            </div>
          </Tooltip>
        );
      })}
    </Row>
  );
};
